import { Link } from "react-router-dom"
import logo from "@/assets/easyeko-logo.svg"

/**
 * Sidebar header: logo EasyEKO (białe na ciemnym tle) + pionowy separator + tracking-wide "CRM".
 * Spójne z BrandPanel na ekranie logowania. "CRM" ukryte na collapsed sidebar (icon-only mode).
 */
export function SidebarBrand() {
  return (
    <Link
      to="/"
      className="flex items-center gap-3 px-1 py-1.5 transition-opacity hover:opacity-80"
      title="EasyEKO CRM"
    >
      <img
        src={logo}
        alt="EasyEKO"
        className="h-7 w-auto shrink-0 brightness-0 invert"
      />
      <span className="text-[11px] font-bold tracking-[0.28em] text-emerald-300/90 border-l border-emerald-300/30 pl-3 py-0.5 group-data-[collapsible=icon]:hidden">
        CRM
      </span>
    </Link>
  )
}
